import React from 'react'
import { format, isValid, parseISO } from 'date-fns'
import { FLAG_STATE } from './constants'

function formatDate(dateStr) {
  if (!dateStr) return ''
  const parsed = parseISO(dateStr)
  return isValid(parsed) ? format(parsed, 'MM/dd/yy') : ''
}

const ACTION_BY_STATE = {
  [FLAG_STATE.DRAFTED]: 'flagged by',
  [FLAG_STATE.REPORTED]: 'flagged by',
  [FLAG_STATE.FIXED]: 'completed by',
  [FLAG_STATE.ACCEPTED]: 'resolved by',
  [FLAG_STATE.NOT_ACCEPTED]: 'flagged by',
}

export function FlagAttribution({ flag, className = 'dome-p3 dome-color-med-grey' }) {
  const { state_performed_at, state_performed_by, state } = flag

  const displayDate = formatDate(state_performed_at)
  const displayName = state_performed_by?.name

  const action = ACTION_BY_STATE[state] ?? 'completed by'

  return (
    <span className={className}>
      {displayDate} {action} {displayName}
    </span>
  )
}
